import { render, staticRenderFns } from "./BeneficiaryBenefit.vue?vue&type=template&id=07ed36bc&"
import script from "./BeneficiaryBenefit.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryBenefit.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryBenefit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/styles/flexben_beneficiary.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports